<template>
  <div>
    <van-nav-bar :right-text="username" left-arrow left-text="返回" title="补货作业" @click-left="onClickLeft" @click-right="goIndex()" />
    <van-field v-model="detail.location.no" label="补出货位" name="补出货位" readonly />
    <van-field v-model="detail.orderType.name" label="订单类型" name="订单类型" readonly />
    <van-field v-model="detail.order.no" label="单据编号" name="单据编号" readonly />
    <van-field v-model="detail.item.no" label="商品编号" name="商品编号" readonly />
    <van-field v-model="detail.item.name" label="通用名称" name="通用名称" readonly />
    <van-field v-model="detail.pack.specification" label="规格" name="规格" readonly />
    <van-field v-model="detail.pack.uom" label="计量单位" name="计量单位" readonly />
    <van-field v-model="detail.pack.factor" label="包装数" name="包装数" readonly />
    <van-field v-model="detail.lot.no" label="批号" name="批号" readonly />
    <van-field v-model="detail.lot.productionDate" label="生产日期" name="生产日期" readonly />
    <van-field v-model="detail.lot.validUntil" label="有效期" name="有效期" readonly />
    <van-field v-model="detail.lot.manufacturer" label="生产厂商" name="生产厂商" readonly />
    <van-field v-model="detail.lot.producingArea" label="产地" name="产地" readonly />
    <van-field v-model="detail.lot.approvalNo" label="批准文号" name="批准文号" readonly />
    <van-row>
      <van-col span="10">
        <van-cell center title="易碎">
          <van-switch slot="right-icon" v-model="detail.item.fragile" active-color="#07c160" disabled inactive-color="#dcdee0" size="24" />
        </van-cell>
      </van-col>
    </van-row>
    <van-row>
      <van-col span="12">
        <van-field v-model="detail.command.quantity" label="数量" name="数量" readonly />
      </van-col>
      <van-col span="12">
        <van-field v-model="detail.numberOfCase" label="件数" name="件数" readonly />
      </van-col>
    </van-row>
    <van-tabbar>
      <van-tabbar-item>
        <van-row gutter="20">
          <van-col span="24">
            <van-button :loading="loading" block round style="margin: 8px;" type="primary" @click="confirm">确认</van-button>
          </van-col>
        </van-row>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>
<script>
  import api from '@/api'
  import { findAll, post } from '@/api/Api'
  import { Toast } from 'vant'
  import { getUser } from '@/pdaView/utils'
  import { ShippingFactoryView } from '@/api/dto/view/ShippingFactoryView'

  export default {
    data() {
      return {
        loading: false,
        username: getUser().name,
        parent: this.$route.params.parent,
        pickingOrderId: this.$route.params.pickingOrderId,
        detail: new ShippingFactoryView()
      }
    },
    created: function() {
      this.refresh()
    },
    methods: {
      goIndex() {
        this.$router.push({ name: 'PdaIndex' })
      },
      onClickLeft() {
        this.$router.push({ name: this.parent })
      },
      refresh() {
        this.loading = true
        const args = {
          'pickingOrder.id': this.pickingOrderId
        }
        findAll('pickingReplenishFactory', args, 1, 1).then(res => {
          if (res.success && res.result.length > 0) {
            const result = res.result[0]
            this.detail = {
              ...result,
              location: result.sourceLocation,
              numberOfCase: Math.ceil(result.command.quantity / result.pack.factor)
            }
          } else {
            this.onClickLeft()
          }
        }).finally(() => this.loading = false)
      },
      confirm() {
        if (!this.detail) {
          Toast('无数据确认！')
          return
        }
        this.loading = true
        const args = {
          'pickingOrder.id': this.detail.pickingOrder.id,
          commandGroup: this.detail.command.commandGroup
        }
        post(api.pickingConfirm, { type: 'replenishmentCommandConfirmer' }, args).then(res => {
          if (res.success) {
            Toast('确认成功！')
            this.refresh()
          }
        }).finally(() => this.loading = false)
      }
    }
  }
</script>